// Minimum width that Copilot Chat Drawer can be. We don't for smaller than this width.
export const MINIMUM_COPILOT_CHAT_DRAWER_WIDTH = 380;

// Initial width that Copilot Chat Drawer would be set to when first opened.
// This is also considered the default width to reset to.
export const DEFAULT_COPILOT_CHAT_DRAWER_WIDTH = 580;

// If the canvas is less than 775px, we enter a specific viewing mode where
// the Copilot Chat Drawer takes up the entire canvas width when opened.
export const NARROWEST_CANVAS_MODE_BREAKPOINT = 775;

// The maximum width that the drawer can be resized to (given enough room) is 60% of the canvas width.
export const MAX_COPILOT_CHAT_DRAWER_WIDTH_CANVAS_RATIO = 0.6;

// For the expand/collapse button, when the expand button is executed, we set the drawer
// to a % of the canvas width. Currently, that ratio is set to 40% of the canvas width.
export const EXPANDED_COPILOT_CHAT_DRAWER_WIDTH_CANVAS_RATIO = 0.4;

// This is the browser width that, when the brwoser is narrower than this number, we will proceed
// with collapsing the folder pane when opening the Copilot Chat Drawer.
export const COLLAPSE_FOLDER_PANE_WHEN_CHAT_OPENED_BREAKPOINT = 1700;
